import React from "react";
import { Outlet } from "react-router-dom";

const WeekReport = () => {

    return (
        <Outlet />
    )
};

export default WeekReport;